import React, { useEffect, useRef } from 'react';
import { FaPaperPlane } from 'react-icons/fa';

const ChatFooter = ({
  value,
  onChange,
  onSend,
  disabled = false,
  placeholder = 'Ask EduGenie…'
}) => {
  const inputRef = useRef(null);

  useEffect(() => {
    if (!disabled && inputRef.current) {
      inputRef.current.focus();
    }
  }, [disabled]);

  const handleKeyDown = (event) => {
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault();
      onSend();
    }
  };

  const canSend = !disabled && value.trim().length > 0;

  return (
    <footer className="edugenie-footer">
      <div className="edugenie-composer">
        <textarea
          ref={inputRef}
          className="edugenie-input"
          rows={1}
          value={value}
          onChange={(event) => onChange(event.target.value)}
          onKeyDown={handleKeyDown}
          placeholder={placeholder}
          disabled={disabled}
          aria-label="Type your message to EduGenie"
        />
        <button
          type="button"
          className="edugenie-send"
          onClick={onSend}
          disabled={!canSend}
          aria-label="Send message"
        >
          <FaPaperPlane />
        </button>
      </div>
      <p className="edugenie-footer-hint">Enter to send · Shift+Enter for new line</p>
      <p className="edugenie-liberate-footer" aria-label="Powered by Liberate">
        Powered by <strong>Liberate</strong>
        <span className="sep" aria-hidden="true">·</span>
        EduGenie
      </p>
    </footer>
  );
};

export default ChatFooter;
